// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"5ded49ec","585":"9a56e1a1"}[chunkId] + ".chunk.js";
};